(function() { window.GUID_a1d92b42_043c_40b6_8cd2_430f51e27c47 = { getGuid: function() { return "a1d92b42-043c-40b6-8cd2-430f51e27c47"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PersonaType;
        (function (PersonaType) {
            PersonaType[PersonaType["User"] = 0] = "User";
            PersonaType[PersonaType["Player"] = 1] = "Player";
            PersonaType[PersonaType["Team"] = 2] = "Team";
            PersonaType[PersonaType["EntityBase"] = 4] = "EntityBase";
            PersonaType[PersonaType["Empty"] = 8] = "Empty";
        })(PersonaType = Enumeration.PersonaType || (Enumeration.PersonaType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PersonaType.pre.js.map
